import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './DraftProsp.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import MarketIPO from "../MarketIPO";
import { Vortex } from 'react-loader-spinner';

function DraftProsp() {
    const [data, setData] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("sebi");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        window.scrollTo(0, 0)
        if (groupValue === "sebi") {
            const getUrl = BaseURL + "DraftProspectus";
            fetch(`${getUrl}/${groupValue}/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    // console.log(getData, "getData")
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "DraftProspectus";
            fetch(`${getUrl}/CLEARED/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }



    }, [groupValue]);

    const routeChange = (event) => {
        const compCoCode = event.currentTarget.dataset.id;
        window.open("http://www.cmlinks.com/pub/dp/dp" + compCoCode + ".pdf");
    }


    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    return (
        <>
            <div class="col-12 p-0 breadcrumIPo ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/ipo">IPO</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Draft Prospectus</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='DraftP-loser-sc'>
                            <div className='DraftP-header'>
                                <h2><span>Draft Prospectus</span></h2>
                            </div>
                            <MarketIPO optionValue="Draft Prospectus" />

                            <div className='DraftP-right'>
                                <div className='DraftP-inner-select'>
                                    
                                    {/* aria-label="Filed With SEBI" */}
                                    <select aria-label="Filed With SEBI" onChange={(event) => { setGroupValue(event.target.value); }}>
                                        <option value="sebi" selected>Filed With SEBI</option>
                                        <option value="CLEARED">Cleared By SEBI</option>
                                    </select>
                                </div>

                            </div>


                            {/* <hr></hr> */}
                            <div className='DraftP-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Company</th>


                                        </tr>

                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ lname, co_code }) => (
                                                <tr>
                                                    <td className="text-left"><h6 onClick={routeChange} data-id={co_code}>{lname}</h6></td>


                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }


                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default DraftProsp;